// import { Box, CssBaseline, Grid, Typography, useMediaQuery, useTheme, Card } from '@mui/material'; // Add Card here
// import React, { useContext, useEffect } from 'react';
// import TempInfoStrip from './TempInfoStrip';
// import { Image } from 'mui-image';
// import GaugeChart from 'react-gauge-chart';
// import { WmcContext } from '../../context/WmcContext';
// import { AuthenticationContext } from '../../context/AuthenticationContext';
// import { Constants } from '../../utils/Constants';
// import { DATA_TYPE, DT1, DT2, PASS_KEY, WEB_KEY } from '../../api/AxiosApi';

// function TempInfoWms() {
//     const { palette, spacing, breakpoints } = useTheme();
//     const { WMCDASHDATA, getWmcMenu, WmcLoading } = useContext(WmcContext);
//     const { LoggedInUserInfo } = useContext(AuthenticationContext);
//     const lgs = useMediaQuery(breakpoints.down('lg'));

//     const LOGIN_ID = localStorage.getItem('LoginID');
//     const LOC_CODE = localStorage.getItem('LCODE');

//     // Fetch data initially and on interval
//     useEffect(() => {
//         getWmcMenu(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, DATA_TYPE, DT1, DT2);
//     }, []);

//     useEffect(() => {
//         const intervalCall = setInterval(() => {
//             getWmcMenu(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, DATA_TYPE, DT1, DT2);
//         }, 60000);
//         return () => clearInterval(intervalCall);
//     }, []);

//     // Sort the data by MENU_INDEX to maintain a consistent order
//     const sortedData = WMCDASHDATA ? [...WMCDASHDATA].sort((a, b) => a?.MENU_INDEX - b?.MENU_INDEX) : [];

//     console.log("storedData", sortedData)
//     const filteredData = sortedData.filter(item => !item?.MENU_NAME.includes('-'));

//     return (
//         <>
//             <CssBaseline />
//             <Box bgcolor={'background.default'} py={spacing(1)}>
//                 <Grid container spacing={spacing(1)}>
//                     {WmcLoading ? (
//                         <Typography variant='body2' textAlign={'center'} width={'100%'}>
//                             Data Loading........
//                         </Typography>
//                     ) : filteredData?.length > 0 ? (
//                         filteredData.map((item, index) => {
//                             const LiveVal = item?.LIVE_VALUE;

//                             return (
//                                 <Grid key={item?.MENU_INDEX || index} item xs={12} sm={12} md={12} lg={3}>
//                                     <TempInfoStrip
//                                         // StartIcon={
//                                         //     Constants()[item?.MENU_NAME] ? (
//                                         //         Constants()[item?.MENU_NAME]
//                                         //     ) : (
//                                         //          <Image width={70} height={'auto'} src={require('../../assets/img/blank.png')} />
//                                         //     )
//                                         // }

//                                         StartIcon={
//                                             item?.MENU_NAME.startsWith('Solar')
//                                                 ? Constants()['Solar Insolation'] // "Solar Insolation" ka icon use karo
//                                                 : Constants()[item?.MENU_NAME]
//                                                     ? Constants()[item?.MENU_NAME]
//                                                     : <Image width={70} height={'auto'} src={require('../../assets/img/blank.png')} />
//                                         }
//                                         WmsCardStyle={{ flex: 1, height: '100%' }}
//                                         title={item?.MENU_NAME}
//                                         boldTitle={
//                                             item?.MENU_NAME === 'Solar Insolation'
//                                                 ? `${item?.['Solar Insolation']} ${item?.UNIT}`
//                                                 : item?.LIVE_VALUE
//                                                     ? `${item?.LIVE_VALUE} ${item?.UNIT}`
//                                                     : '____'
//                                         }
//                                         LiveDate={
//                                             item?.MENU_NAME === 'Solar Insolation'
//                                                 ? item?.['Date']
//                                                 : item?.LIVE_DATE_TIME
//                                                     ? item?.LIVE_DATE_TIME
//                                                     : '____'
//                                         }
//                                         rightTitle={
//                                             item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
//                                                 ? null
//                                                 : item?.UD
//                                         }
//                                         minValue={
//                                             item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
//                                                 ? null
//                                                 : item?.MIN_VALUE || '____'
//                                         }
//                                         maxValue={
//                                             item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
//                                                 ? null
//                                                 : item?.MAX_VALUE || '____'
//                                         }
//                                         avgValue={
//                                             item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
//                                                 ? null
//                                                 : item?.AVG_VALUE || '____'
//                                         }
//                                         tempMeters={
//                                             <Box>
//                                                 <GaugeChart
//                                                     id="gauge-chart5"
//                                                     nrOfLevels={420}
//                                                     arcsLength={[0.3, 0.5, 0.2]}
//                                                     colors={['#FED7AA', '#FB923C', '#EA580C']}
//                                                     percent={LiveVal}
//                                                     textColor={palette.primary.dark}
//                                                     cornerRadius={0}
//                                                     hideText
//                                                     animate={false}
//                                                     style={{ width: '7rem', margin: 'auto' }}
//                                                     arcPadding={0.0}
//                                                 />
//                                                 <Typography
//                                                     noWrap
//                                                     component={Card} // Card is used here
//                                                     bgcolor={palette.primary.light}
//                                                     width={'5rem'}
//                                                     m={'auto'}
//                                                     textAlign={'center'}
//                                                     variant='body1'>
//                                                     {item?.MENU_NAME === 'Solar Insolation'
//                                                         ? `${item?.['Solar Insolation']} ${item?.UNIT}`
//                                                         : LiveVal
//                                                             ? `${LiveVal} ${item?.UNIT}`
//                                                             : '____'}
//                                                 </Typography>
//                                             </Box>
//                                         }
//                                     />
//                                 </Grid>
//                             );
//                         })
//                     ) : (
//                         // <Typography variant='body2' width={'100%'} textAlign={'center'}>
//                         //     Data not found
//                         // </Typography>
//                         null
//                     )}
//                 </Grid>
//             </Box>
//         </>
//     );
// }

// export default TempInfoWms




import { Box, CssBaseline, Grid, Typography, useMediaQuery, useTheme, Card } from '@mui/material'; // Add Card here
import React, { useContext, useEffect } from 'react';
import TempInfoStrip from './TempInfoStrip';
import { Image } from 'mui-image';
import GaugeChart from 'react-gauge-chart';
import { WmcContext } from '../../context/WmcContext';
import { AuthenticationContext } from '../../context/AuthenticationContext';
import { Constants } from '../../utils/Constants';
import { DATA_TYPE, DT1, DT2, PASS_KEY, WEB_KEY } from '../../api/AxiosApi';

function TempInfoWms() {
    const { palette, spacing, breakpoints } = useTheme();
    const { WMCDASHDATA, getWmcMenu, WmcLoading } = useContext(WmcContext);
    const { LoggedInUserInfo } = useContext(AuthenticationContext);
    const lgs = useMediaQuery(breakpoints.down('lg'));

    const LOGIN_ID = localStorage.getItem('LoginID');
    const LOC_CODE = localStorage.getItem('LCODE');

    // Helper function to check if date is today
    const isToday = (dateTimeString) => {
        if (!dateTimeString) return false;
        const today = new Date();
        const inputDate = new Date(dateTimeString);

        return (
            inputDate.getDate() === today.getDate() &&
            inputDate.getMonth() === today.getMonth() &&
            inputDate.getFullYear() === today.getFullYear()
        );
    };

    // Fetch data initially and on interval
    useEffect(() => {
        getWmcMenu(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, DATA_TYPE, DT1, DT2);
    }, []);

    useEffect(() => {
        const intervalCall = setInterval(() => {
            getWmcMenu(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, DATA_TYPE, DT1, DT2);
        }, 300000);
        return () => clearInterval(intervalCall);
    }, []);

    // Sort the data by MENU_INDEX to maintain a consistent order
    const sortedData = WMCDASHDATA ? [...WMCDASHDATA].sort((a, b) => a?.MENU_INDEX - b?.MENU_INDEX) : [];

    // console.log("storedData", sortedData)
    const filteredData = sortedData.filter(item => !item?.MENU_NAME.includes('-'));

    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>
                <Grid container spacing={spacing(1)}>
                    {WmcLoading ? (
                        <Typography variant='body2' textAlign={'center'} width={'100%'}>
                            Data Loading........
                        </Typography>
                    ) : filteredData?.length > 0 ? (
                        filteredData.map((item, index) => {
                            const LiveVal = item?.LIVE_VALUE;

                            return (
                                <Grid key={item?.MENU_INDEX || index} item xs={12} sm={12} md={12} lg={3}>
                                    <TempInfoStrip
                                        StartIcon={
                                            item?.MENU_NAME.startsWith('Solar')
                                                ? Constants()['Solar Insolation']
                                                : Constants()[item?.MENU_NAME]
                                                    ? Constants()[item?.MENU_NAME]
                                                    : <Image width={70} height={'auto'} src={require('../../assets/img/blank.png')} />
                                        }
                                        WmsCardStyle={{ flex: 1, height: '100%' }}
                                        title={
                                            // <Typography
                                            //     variant="subtitle1"
                                            //     sx={{
                                            //         color: isToday(item?.LIVE_DATE_TIME) ? palette.text.primary : 'red',
                                            //         fontWeight: 'bold'
                                            //     }}
                                            // >
                                            //     {item?.MENU_NAME}
                                            // </Typography>

                                            <Typography
                                                variant=""
                                                sx={{
                                                    
                                                    color:
                                                        item?.MENU_NAME === 'Solar Insolation'
                                                            ? palette.text.primary
                                                            : (() => {
                                                                const now = new Date();
                                                                const liveTime = new Date(item?.LIVE_DATE_TIME);
                                                                const diffMs = now - liveTime;
                                                                const diffMins = diffMs / (1000 * 60);

                                                                return diffMins > 60 ? 'red' : 'green';
                                                            })()
                                                }}
                                            >
                                                {item?.MENU_NAME}
                                            </Typography>

                                        }
                                        boldTitle={
                                            item?.MENU_NAME === 'Solar Insolation'
                                                ? `${item?.['Solar Insolation']} ${item?.UNIT}`
                                                : item?.LIVE_VALUE
                                                    ? `${item?.LIVE_VALUE} ${item?.UNIT}`
                                                    : '____'
                                        }
                                        LiveDate={
                                            item?.MENU_NAME === 'Solar Insolation'
                                                ? item?.['Date']
                                                : item?.LIVE_DATE_TIME
                                                    ? item?.LIVE_DATE_TIME
                                                    : '____'
                                        }
                                        rightTitle={
                                            item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
                                                ? null
                                                : item?.UD
                                        }
                                        minValue={
                                            item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
                                                ? null
                                                : item?.MIN_VALUE || '____'
                                        }
                                        maxValue={
                                            item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
                                                ? null
                                                : item?.MAX_VALUE || '____'
                                        }
                                        avgValue={
                                            item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
                                                ? null
                                                : item?.AVG_VALUE || '____'
                                        }
                                        tempMeters={
                                            <Box>
                                                <GaugeChart
                                                    id="gauge-chart5"
                                                    nrOfLevels={420}
                                                    arcsLength={[0.3, 0.5, 0.2]}
                                                    colors={['#FED7AA', '#FB923C', '#EA580C']}
                                                    percent={LiveVal}
                                                    textColor={palette.primary.dark}
                                                    cornerRadius={0}
                                                    hideText
                                                    animate={false}
                                                    style={{ width: '7rem', margin: 'auto' }}
                                                    arcPadding={0.0}
                                                />
                                                <Typography
                                                    noWrap
                                                    component={Card}
                                                    bgcolor={palette.primary.light}
                                                    width={'5rem'}
                                                    m={'auto'}
                                                    textAlign={'center'}
                                                    variant='body1'>
                                                    {item?.MENU_NAME === 'Solar Insolation'
                                                        ? `${item?.['Solar Insolation']} ${item?.UNIT}`
                                                        : LiveVal
                                                            ? `${LiveVal} ${item?.UNIT}`
                                                            : '____'}
                                                </Typography>
                                            </Box>
                                        }
                                    />
                                </Grid>
                            );
                        })
                    ) : (
                        null
                    )}
                </Grid>
            </Box>
        </>
    );
}

export default TempInfoWms;
